import { useApolloClient } from '@apollo/client'
import { useGraphqlFetchAndCache } from '@mostrans/web-components/hooks/useGraphqlFetchAndCache'
import { MasterTestimonialForPublicAtom } from './TestimonialAtoms'
import { getMasterTestimoniForPublic } from './TestimonialQueries'

export const useGetMasterTestimoniForPublic = () => {
    const client = useApolloClient()
    return useGraphqlFetchAndCache({
        atom: MasterTestimonialForPublicAtom,
        initialValue: [],
        getData: () => getMasterTestimoniForPublic(client),
        variables: {}
    })
}
